import * as React from 'react';
import { useContext } from 'react';

type PageContextType = {
  isEnterprise?: boolean;
  isConsumer?: boolean;
};

const PageContext = React.createContext<PageContextType | undefined>(undefined);

/**
 * @description Hook to access the unified home page type (enterprise or consumer)
 */
export const usePageContext = () => {
  const context = useContext(PageContext);

  return context;
};

export default PageContext;
